module.exports = __webpack_public_path__ + "other-loan-type-cover.4fc7846.png";